export function reorderData(data, activeItem, dataItem, direction) {
    if (activeItem === dataItem) {
        return data;
    }
    const reorderedData = data.slice();
    let prevIndex = reorderedData.findIndex((p) => p.id === activeItem.id);
    let nextIndex = reorderedData.findIndex((p) => p.id === dataItem.id) + (direction === "before" ? -1 : 0);
    if (prevIndex > nextIndex) {
        nextIndex++;
    }
    reorderedData.splice(prevIndex, 1);
    reorderedData.splice(nextIndex, 0, activeItem || reorderedData[0]);
    return reorderedData;
}